import React from 'react';
import { Link } from 'react-router-dom';
import heroImage from '../../../../assets/images/wealthandsavingsdetails/hero/hero.jpg';
import './Hero.css';

const renderMultilineText = (text) =>
  text.split('\n').map((line, index, lines) => (
    <React.Fragment key={`${line}-${index}`}>
      {line}
      {index < lines.length - 1 ? <br /> : null}
    </React.Fragment>
  ));

const Hero = ({ category, title, description, cta, image }) => {
  if (!title) {
    return null;
  }

  return (
    <section className="wealth-details-hero">
      <div className="wealth-details-hero__inner">
        <div className="wealth-details-hero__copy">
          {category ? <p className="wealth-details-hero__eyebrow">{category}</p> : null}
          <h1 className="wealth-details-hero__title">{renderMultilineText(title)}</h1>
          {description ? <p className="wealth-details-hero__text">{description}</p> : null}
          {cta?.text && cta?.url ? (
            <Link to={cta.url} className="wealth-details-hero__cta luxury-btn">
              {cta.text}
            </Link>
          ) : null}
        </div>
      </div>

      <div className="wealth-details-hero__media">
        <img
          className="wealth-details-hero__image"
          src={image || heroImage}
          alt=""
          aria-hidden="true"
        />
      </div>
    </section>
  );
};

export default Hero;
